/**
 * Mobile UX 2030 - JavaScript Enhancement
 * Foxx Life Sciences
 * VERSION: 2024-11-25 (Black Friday SKU-Based Discounts)
 * 
 * Features:
 * - Mobile search drawer
 * - Mobile sidebar drawer
 * - Smooth animations
 * - Keyboard accessibility
 * - Total product count from main search API
 * - SKU-based Black Friday discounts (50%, 25%, 10%)
 */

console.log('🔄 Mobile UX 2030 JS loaded - VERSION: 2024-11-25 (Black Friday SKU-Based Discounts)');

(function() {
  'use strict';
  
  // SKU-based discount tiers for Black Friday
  const SKUS_50_PERCENT = ['AQG33024HT-25','AQG33012-5','AQS33012HT-5','627-1101-FLS','627-2101-FLS','627-3101-FLS','627-4101-FLS','627-5101-FLS','158-1111-OEM','158-3121-OEM','158-2111-OEM','152-3211-VWR','152-2111-OEM','158-0111-OEM','155-3211-OEM','157-3121-OEM','152-3111-OEM','155-3221-OEM','152-1211-OEM','155-2111-OEM','152-3211-OEM','155-0111-OEM','155-2211-OEM','155-1111-OEM','155-5121-OEM','152-3121-OEM','15N-1111-OEM','152-5221-OEM','155-5221-OEM'];
  
  const SKUS_25_PERCENT = ['11012-FLS','1101-FLS','1102-FLS','1103-FLS','1116-RLS','1122-RLS','11412-FLS','11422-FLS','1142-FLS','11432-FLS','1143-FLS','11512-FLS','1152-FLS','11532-FLS','1153-FLS','116-11132-FLS','11612-FLS','116-21132-FLS','116-2113-FLS','11622-FLS','1162-FLS','116-31132-FLS','116-3113-FLS','11632-FLS','1163-FLS','116-71132-FLS','116-81132-FLS','116-8113-FLS','116-9113-FLS','11712-FLS','1171-RLS','11722-FLS','1172-RLS','11732-FLS','1173-RLS','11762-FLS','11772-FLS','11782-FLS','1181-RLS','1182-RLS','137-1116-FLS','137-1117-FLS','137-2211-FLS','137-2213-FLS','137-3214-FLS','137-3215-FLS','137-4214-FLS','137-5211-FLS','137-6513-FLS','138-1111-FLS','138-2211-FLS','138-2213-FLS','138-3213-FLS','138-4211-FLS','138-4213-FLS','138-5213-FLS','138-6511-FLS','138-6513-FLS','1501016-FLS','1501018-FLS','1501021-FLS','1501024-FLS','1501029-FLS','1501030-FLS','1501031-FLS','1501033-FLS','1501038-FLS','1501040-FLS','1519016-FLS','1519021-FLS','1519024-FLS','1519029-FLS','1519030-FLS','1519031-FLS','1519038-FLS','152-0111-OEM','152-1111-OEM','152-3221-OEM','152-5121-OEM','152-7121-OEM','152-B191-FLS','152-C191-FLS','1551040-FLS','155-1211-OEM','155-3111-OEM','155-3121-OEM','155-7121-OEM','155-B117-FLS','155-B187-FLS','155-B817-FLS','155-C117-FLS','155-C187-FLS','155-C817-FLS','155-J897-FLS','155-K897-FLS','155-L897-FLS','157-0111-OEM','157-1211-OEM','157-2111-OEM','157-2211-OEM','157-3221-OEM','162-1102-OEM','162-2102-OEM','162-4201-OEM','162-4202-OEM','165-1102-OEM','165-1111-FLS','165-1114-FLS','165-2102-OEM','165-2111-FLS','165-4203-OEM','225-1001-RLS','225-4002-RLS','225-4003-RLS','225-4004-RLS','225-4005-RLS','225-4006-RLS','248-4132-OEM','248-4142-OEM','248-4231-OEM','248-4232-OEM','248-4242-OEM','248-5131-OEM','248-5132-OEM','248-5142-OEM','248-5231-OEM','248-5242-OEM','252-1901-OEM','252-1902-OEM','252-1903-OEM','252-1904-OEM','252-1906-OEM','252-1907-OEM','252-1908-OEM','302-1101-FLS','302-2001-FLS','302-2101-FLS','302-4101-FLS','302-4401-FLS','305-1001-FLS','305-1101-FLS','305-2001-FLS','305-2002-FLS','305-2003-FLS','305-2004-FLS','305-2101-FLS','305-4001-FLS','305-4002-FLS','305-4003-FLS','305-4004-FLS','305-4101-FLS','305-4103-FLS','305-4201-FLS','305-4203-FLS','305-4401-FLS','305-4403-FLS','30R-1101-FLS','30R-2001-FLS','30R-2101-FLS','30R-2201-FLS','30R-3101-FLS','30R-4101-FLS','30R-4201-FLS','310-1101-FLS','310-2001-FLS','310-2101-FLS','310-2201-FLS','310-4101-FLS','310-4201-FLS','315-1001-FLS','315-1101-FLS','315-2001-FLS','315-2002-FLS','315-2003-FLS','315-2004-FLS','315-2101-FLS','315-4001-FLS','315-4002-FLS','315-4003-FLS','315-4004-FLS','315-4101-FLS','315-4103-FLS','315-4201-FLS','315-4203-FLS','315-4401-FLS','315-4403-FLS','338-1111-FLS','338-3211-FLS','338-6511-FLS','338-6513-FLS','400-FLS','523-1001-FLS','523-2001-FLS','523-3001-FLS','523-4001-FLS','525-1001-FLS','525-3001-FLS','525-4001-FLS','531-1001-FLS','531-3001-FLS','531-4001-FLS','533-1001-FLS','533-3001-FLS','533-4001-FLS','627-1102-FLS','627-2102-FLS','627-3102-FLS','627-4102-FLS','627-5102-FLS','627-8102-FLS','62T-1101-FLS','62T-2101-FLS','62T-3101-FLS','62T-4101-FLS','62T-5101-FLS','62T-6101-FLS','62T-7101-FLS','62T-8101-FLS','62T-9101-FLS','630-FLS','650-FLS','660-FLS','746-2001-FLS','746-2002-FLS','746-2003-FLS','746-2004-FLS','746-2005-FLS','746-2006-FLS','746-2007-FLS','746-2101-FLS','746-2102-FLS','746-2103-FLS','746-2104-FLS','746-2105-FLS','746-2106-FLS','746-2107-FLS','746-3001-FLS','746-3002-FLS','746-3003-FLS','746-3004-FLS','746-3005-FLS','746-3006-FLS','746-3007-FLS','746-3101-FLS','746-3102-FLS','746-3103-FLS','746-3104-FLS','746-3105-FLS','746-3106-FLS','746-3107-FLS','746-3116-FLS','748-2001-FLS','748-2101-FLS','748-3001-FLS','748-3101-FLS'];
  
  const SKUS_10_PERCENT = ['1000005','1000006','1000009','1060012','1060018','1060028','1500016','1500017','1500021','1500024','1506024','1506029','1506033','1509013','1509016','1509017','1509021','1509024','1509030','1585021','1585024','1585029','1585030','1585031','1585033','1585038','1585040','1585046','1630007','1630008','1630009','1630011','1630013','2400087','2400090','2400092','2480087','2480090','2480092','2480096','2560090','2560095','2641087','2641090','2641187','2641190','3027005','3027016','3027021','3027024','3027029','3082041','3082042','3082043','3082044','3082045','3083040','3083041','3083042','3083043','3083044','3083045','3084042','3084044','3160065','3160077','3160081','3840013','3840016','3840020','3840024','3840030','4060009','4060012','4060016','4060018','4060021','4060022','4060024','4060029','4060030','4060031','4060033','4060034','4060038','4060040','4260009','4260012','4260016','4260018','4260021','4260024','4260030','4260031','4260033','4260034','4260038','4260040','4980009','4980012','4980016','4980018','4980021','4980024','4980029','4980030','4980031','4980033','5000009','5000012','5000016','5000021','5000024','5020009','5020012','5020016','5020021','5020024','5020029','5020030','5340012','5340016','5340021','5340024','5340029','5340030','5340033','5340038','5340040','5350033','5350130','6140058','6140065','6140069','6140071','6140077','6402013','6402017','6402021','6402024','6402029','6402030','6403017','6403021','6403024','6403029','6403030','7101003','7101004','7101005','7101006','7101007','7101008','7101010','7101011','7101012','7101016','7101205','7101705','7101706','7101707','7101708','7101709','7101711','7103001','7103002','7103003','7103004','7103005','7103006','7103007','7103008','7103009','7103010','7103011','7103012','7103016','7103706','7103708','7103709','8100045','8100055','8300007','8400045','8400055','9830007','9830016','9850107','9850109','9850207','9850209','9850307','9850309','9850407','9900005','9900006','9900010','9900012','9900013','9900018','9901005','9901006','9901010','9901013','9901018','9910005','9910007','9910010','9910012','9911007','9911010','9986072','9986077','9986079','9986081','1000D12','1000D16','1000D18','1000D21','1000D23','1000D25','1000D28','1000D29','1000D33','1060D21','1060D24','1060D29','1101-RLS','1102-RLS','1103-RLS','1142-RLS','1143-RLS','1151-RLS','1152-RLS','1153-RLS','1161-RLS','116-2113-RLS','1162-RLS','116-3113-RLS','12013-00','12013-01','12013-02','12013-03','12013-04','12013-05','12013-06','12013-07','12013-09','12013-10','12013-11','12013-12','12014-00','12014-01','12014-02','12014-03','12014-04','12014-05','12014-06','12014-07','12014-09','12014-10','12014-11','12014-12','152-3111-FLS','152-5111-FLS','155-5211-FLS','157-0211-FLS','157-1111-FLS','157-5211-FLS','158-7111-FLS','15N-3111-FLS','15W-0211-FLS','15W-0221-FLS','15W-1211-FLS','15W-1221-FLS','15W-3111-FLS','15W-3121-FLS','15W-3211-FLS','15W-3221-FLS','16N-1102-FLS','16N-4201-FLS','2400089','2400094','2480094','3000016','3000029','3082030','3083030','3084030','3151003','3520010','3520016','3520021','4060032','4260032','4510009','4510016','4510018','4510021','4510024','4510029','4510030','4510033','4510038','4510040','4540008','4540009','4540012','4540016','4540018','4540021','4540022','4540024','4540029','4540030','4540031','4540033','4540034','4540038','4540040','4550009','4550012','4550016','4550018','4550021','4550024','4550029','4550030','4550031','4550033','4550038','4980032','5020032','5020033','5020034','5200009','5200012','5200016','5200021','5200024','5200029','5200030','5240009','5240012','5240016','5240018','5240021','5240024','5240029','5240030','5240031','5240033','5240034','5240038','5240040','5250009','5250012','5250016','5250021','5250024','5250029','5250030','5300009','5300012','5300016','5300021','5300024','5300029','5300030','5340031','5350131','5350231','5530009','5530012','5530016','5530021','5530024','5530029','5530030','5530038','5530040','5540008','5540009','5540012','5540016','5540018','5540021','5540024','5540029','5540030','5540031','5540033','5540038','5540040','5550009','5550012','5550016','5550021','5550024','5550029','5550030','5550031','5550033','5550034','5550038','5580009','5580012','5580016','5580021','5580024','5580029','5580030','627-FLS','6402032','6402033','6402034','6402038','6403032','6403033','6403034','6403038','6420009','6420012','6420016','6420021','6420024','6420029','6420030','6420033','6420038','6420040','6430009','6430012','6430016','6430021','6430024','6430029','6430030','6430033','6430038','710-5000-FLS','710-5001-FLS','710-5002-FLS','710-5003-FLS','710-5005-FLS','7501003','7501005','7501005R','7501006','7501006R','7501007','7501007R','7501011','7501012','7501016','7501030','7501031','7501047','7501048','7501049','7501050','7501051','7501052','7501053','7501054','7501055','7501056','7501059','7501060','7501061','7501062','7501063','7501064','7501065','7501066','7501067','7501068','7501070','7501071','7501073','7501074','7501075','7501076','7501077','7501080','7501081','7501082','7501083','7501085','7501086','7501087','7501088','7501089','7503003','7503005','7503006','7503007','7503010','7503011','7503012','7503013','7503016','7503030','7503031','7503036','7503047','7503048','7503050','7503051','7503052','7503053','7503054','7503055','7503059','7503060','7503061','7503062','7503063','7503064','7503065','7503066','7503067','7503068','7503069','7503070','7503071','7503073','7503074','7503075','7503076','7503077','7503079','7503080','7503081','7503082','7503083','7503084','7503085','7503086','7503087','7503088','7503089','7503106','7503107','7503108','7503110','7503112','7503113','7503115','7503116','7503117','7503122','7503124','7503125','7503126','7503127','7503132','7503134','7503135','7503136','7503137','7503147','7503148','7503151','7503152','7503153','7503154','7503155','7503156','7503162','7503165','7503166','7503167','7503168','8200007','8200045','8200055','9830009','9830013','9830016-10','9830021','9830024','9830030','9900014','9901001','9901014','9910001','9910014','9910016','9912007','AQG33008-50','AQG33009-50','AQG33012-50','AQG33013-50','AQG33016-50','AQG33022-50','AQS33008HT-5','AQS33009HT-5','AQS33012HT-50','AQS33013HT-5','AQS33016HT-5','AQS33024HT-50','AQS33039-5','CAPH-33013-50','CAPH-33017-100','CAPH-33022-50','CAPH-33025-100','CAPH-33025-50','CAPH-33030-100','CAPH-33030-200','CAPH-33030-50','CAPH-33030HT-50','CAPH-33033HT-50','EK-1016-FLS','EK-1024-FLS','EK-1029-FLS','EK-1033-FLS','EK-1109-FLS','EK-1116-FLS','EK-1121-FLS','EK-1124-FLS','EK-1509-FLS','EK-1516-FLS','EK-1521-FLS','EK-1524-FLS','EK-1529-FLS','EZLBL-0.20-AQ-13MM-100','EZLBL-0.20-AQ-13MM-1000','EZLBL-0.22-AQ-13MM-1000','EZLBL-0.22-AQ-13MM-100','EZLBL-0.22-AQ-13MM-500','EZLBL-0.22-AQ-13MM-50','EZLBL-0.22-AQ-25MM-100','EZLBL-0.22-AQ-25MM-200','EZLBL-0.22-AQ-25MM-50','EZLBL-0.22-AQ-30MM-100','EZLBL-0.22-HT-13MM-100','EZLBL-0.22-HT-13MM-1000','EZLBL-0.22-HT-13MM-500','EZLBL-0.22-HT-25MM-100','EZLBL-0.22-HT-25MM-200','EZLBL-0.22-HT-30MM-100','EZLBL-0.45-AQ-13MM-100','EZLBL-0.45-AQ-13MM-1000','EZLBL-0.45-AQ-13MM-500','EZLBL-0.45-AQ-25MM-100','EZLBL-0.45-AQ-25MM-200','EZLBL-0.45-AQ-30MM-100','EZLBL-0.45-HT-13MM-100','EZLBL-0.45-HT-13MM-1000','EZLBL-0.45-HT-13MM-500','EZLBL-0.45-HT-25MM-100','EZLBL-0.45-HT-25MM-200','EZLBL-0.45-HT-30MM-100','EZSP-0.22-AQ-13MM-100','EZSP-0.22-AQ-13MM-1000','EZSP-0.22-AQ-13MM-500','EZSP-0.22-AQ-30MM-100','EZSP-0.22-HT-13MM-100','EZSP-0.22-HT-13MM-1000','EZSP-0.22-HT-13MM-500','EZSP-0.22-HT-30MM-100','EZSP-0.45-AQ-13MM-100','EZSP-0.45-AQ-13MM-1000','EZSP-0.45-AQ-13MM-500','EZSP-0.45-AQ-30MM-100','EZSP-0.45-HT-13MM-100','EZSP-0.45-HT-13MM-1000','EZSP-0.45-HT-13MM-500','EZSP-0.45-HT-30MM-100','PH-33009-100','PH-33012-100','PH-33012-50','PH-33013-100','PH-33013-50','PH-33015-100','PH-33016-100','PH-33016-50','PH-33017-100','PH-33017-50','PH-33022-100','PH-33022-50','PH-33025-100','PH-33025-50','PH-33030-100','PH-33030-50','PH-33030HT-100','PH-33030HT-50','PH-33033HT-50','PH-33037-100','PH-33039HT-50','SA-33009-25','SA-33012-25','SA-33013-25','SA-33015-25','SA-33016-25','SA-33025-25','SA-33030-25','YF1-1101-FLS','YF1-2101-FLS','YF1-3101-FLS','YF1-4101-FLS','YF1-5101-FLS','YF1-6101-FLS','YF1-7101-FLS','YF1-8101-FLS','YF2-1102-FLS','YF2-2102-FLS','YF2-3102-FLS','YF2-4102-FLS','YF2-5102-FLS','YF2-6102-FLS','YF2-7102-FLS','YF2-8102-FLS','YF3-1102-FLS','YF3-2102-FLS','YF3-3102-FLS','YF3-4102-FLS','YF3-5102-FLS','YF3-6102-FLS','YF3-7102-FLS','YF3-8102-FLS','YF5-1101-FLS','YF5-2101-FLS','YF5-3101-FLS','YF5-4101-FLS','YF5-5101-FLS','YF5-6101-FLS','YF5-7101-FLS','YF5-8101-FLS','EZFS-0.22-AQ-33MM-100','EZFS-0.22-AQ-33MM-500','EZFS-0.22-AQ-33MM-50','EZFS-0.45-AQ-33MM-100','EZFS-0.45-AQ-33MM-500','EZFS-0.45-AQ-33MM-50','EZLBL-0.22-AQ-13MM-1500'];
  
  /**
   * Get Black Friday discount percentage based on SKU
   */
  function getSkuDiscount(sku) {
    if (!sku) return 0;
    const skuUpper = sku.toUpperCase();
    if (SKUS_50_PERCENT.includes(skuUpper)) return 50;
    if (SKUS_25_PERCENT.includes(skuUpper)) return 25;
    if (SKUS_10_PERCENT.includes(skuUpper)) return 10;
    return 0;
  }

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initMobileSearch();
    initMobileSidebar();
    initSearchEnhancements();
    initScrollModalClose();
  }

  /**
   * Mobile Search Drawer Functionality
   */
  function initMobileSearch() {
    // Create mobile search drawer HTML
    const searchDrawerHTML = `
      <div class="mobile-search-overlay" id="mobileSearchOverlay">
        <div class="mobile-search-drawer" id="mobileSearchDrawer">
          <div class="mobile-search-header">
            <h2 class="mobile-search-title">Search Products</h2>
            <button class="mobile-search-close" id="mobileSearchClose" aria-label="Close search">
              ×
            </button>
          </div>
          <div class="mobile-search-body">
            <div class="mobile-search-input-wrapper">
              <svg class="mobile-search-icon" viewBox="0 0 24 24">
                <circle cx="11" cy="11" r="8"></circle>
                <path d="M21 21l-4.35-4.35"></path>
              </svg>
              <input 
                type="search" 
                class="mobile-search-input" 
                placeholder="Search our store..." 
                id="mobileSearchInput"
                autocomplete="off"
              />
            </div>
            <div id="mobileSearchResults"></div>
          </div>
        </div>
      </div>
    `;

    // Insert drawer into DOM
    document.body.insertAdjacentHTML('beforeend', searchDrawerHTML);

    // Get elements
    const overlay = document.getElementById('mobileSearchOverlay');
    const drawer = document.getElementById('mobileSearchDrawer');
    const closeBtn = document.getElementById('mobileSearchClose');
    const searchInput = document.getElementById('mobileSearchInput');

    // Get the existing mobile search input (don't replace it, just make it clickable)
    const mobileSearchContainer = document.querySelector('.large--hide .header-bar__search');
    const originalMobileInput = document.querySelector('.large--hide .header-bar__search-input');
    
    if (originalMobileInput && window.innerWidth <= 768) {
      // Add shorter placeholder for compact mobile button
      if (!originalMobileInput.placeholder || originalMobileInput.placeholder.trim() === '') {
        originalMobileInput.placeholder = 'Search';
      } else {
        // Override with shorter text for mobile
        originalMobileInput.placeholder = 'Search';
      }
      
      // Make the input readonly and clickable (opens drawer instead of typing)
      originalMobileInput.setAttribute('readonly', 'true');
      originalMobileInput.style.cursor = 'pointer';
      
      // Click on mobile search input opens drawer
      originalMobileInput.addEventListener('click', function(e) {
        e.preventDefault();
        overlay.classList.add('active');
        drawer.classList.add('active');
        document.body.style.overflow = 'hidden';
        setTimeout(() => searchInput.focus(), 400);
      });
      
      // Prevent form submission on mobile
      const mobileForm = originalMobileInput.closest('form');
      if (mobileForm) {
        mobileForm.addEventListener('submit', function(e) {
          e.preventDefault();
          overlay.classList.add('active');
          drawer.classList.add('active');
          document.body.style.overflow = 'hidden';
          setTimeout(() => searchInput.focus(), 400);
        });
      }
    }

    // Close drawer
    function closeSearch() {
      overlay.classList.remove('active');
      drawer.classList.remove('active');
      document.body.style.overflow = '';
    }

    closeBtn.addEventListener('click', closeSearch);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        closeSearch();
      }
    });

    // Escape key to close
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('active')) {
        closeSearch();
      }
    });

    // Connect to existing Shopify search with live results
    if (searchInput) {
      const resultsContainer = document.getElementById('mobileSearchResults');
      let searchTimeout;

      // Live search as user types
      searchInput.addEventListener('input', function() {
        const query = this.value.trim();
        
        clearTimeout(searchTimeout);
        
        if (query.length < 2) {
          resultsContainer.innerHTML = '';
          return;
        }

        // Show loading state
        resultsContainer.innerHTML = '<div class="search-loading">Searching...</div>';

        // Debounce search
        searchTimeout = setTimeout(() => {
          performSearch(query, resultsContainer);
        }, 300);
      });

      // Submit on Enter
      searchInput.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          const searchTerm = this.value.trim();
          if (searchTerm) {
            window.location.href = `/search?q=${encodeURIComponent(searchTerm)}`;
          }
        }
      });
    }
  }

  /**
   * Perform live product search
   */
  function performSearch(query, resultsContainer) {
    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`)
      .then(response => response.json())
      .then(data => {
        displaySearchResults(data, resultsContainer, query);
      })
      .catch(error => {
        console.error('Search error:', error);
        resultsContainer.innerHTML = '<div class="search-error">Search unavailable. Please try again.</div>';
      });
  }

  /**
   * Display search results
   */
  function displaySearchResults(data, container, query) {
    if (!data.resources || !data.resources.results || !data.resources.results.products) {
      container.innerHTML = '<div class="search-no-results">No products found</div>';
      return;
    }

    const products = data.resources.results.products;
    
    if (products.length === 0) {
      container.innerHTML = '<div class="search-no-results">No products found</div>';
      return;
    }

    let html = '<div class="search-results-list">';
    
    products.forEach(product => {
      // Price is already in dollars for this store (not cents!)
      let priceInDollars = product.price ? parseFloat(product.price) : 0;
      
      // Get SKU and apply SKU-based Black Friday discount
      let sku = '';
      if (product.variants && product.variants.length > 0 && product.variants[0].sku) {
        sku = product.variants[0].sku;
      } else if (product.sku) {
        sku = product.sku;
      }
      
      const discountPercent = getSkuDiscount(sku);
      const additionalDiscount = priceInDollars * (discountPercent / 100);
      const finalPrice = priceInDollars - additionalDiscount;
      const price = finalPrice > 0 ? finalPrice.toFixed(2) : 'N/A';
      
      const image = product.image || '/assets/placeholder.png';
      
      html += `
        <a href="${product.url}" class="search-result-item">
          <div class="search-result-image">
            <img src="${image}" alt="${product.title}" loading="lazy">
          </div>
          <div class="search-result-info">
            <div class="search-result-title">${product.title}</div>
            <div class="search-result-price">$${price}</div>
          </div>
        </a>
      `;
    });
    
    html += '</div>';
    html += `<a href="/search?q=${encodeURIComponent(query)}" class="search-view-all">View all results →</a>`;
    
    container.innerHTML = html;
  }

  /**
   * Mobile Sidebar Drawer Functionality
   */
  function initMobileSidebar() {
    // Only run on mobile
    if (window.innerWidth > 768) return;

    // Get the sidebar content from desktop
    const desktopSidebar = document.querySelector('.sticky-content.c-sticky-content .sticky-items');
    if (!desktopSidebar) return;

    // Clone sidebar content
    const sidebarContent = desktopSidebar.cloneNode(true);

    // Create mobile sidebar drawer HTML
    const sidebarDrawerHTML = `
      <div class="sidebar-overlay" id="sidebarOverlay"></div>
      <div class="mobile-sidebar-drawer" id="mobileSidebarDrawer">
        <div class="mobile-sidebar-header">
          <h2 class="mobile-sidebar-title">
            <span class="sidebar-logo-icon">F</span>
            Categories
          </h2>
          <button class="mobile-sidebar-close" id="mobileSidebarClose" aria-label="Close menu">
            ×
          </button>
        </div>
        <div class="mobile-sidebar-content" id="mobileSidebarContent">
        </div>
      </div>
    `;

    // Insert drawer into DOM
    document.body.insertAdjacentHTML('beforeend', sidebarDrawerHTML);

    // Add cloned content
    const contentContainer = document.getElementById('mobileSidebarContent');
    contentContainer.appendChild(sidebarContent);

    // Create NEW sidebar trigger button (separate from menu)
    const sidebarTriggerHTML = `
      <button class="mobile-sidebar-trigger" id="mobileSidebarTrigger" aria-label="Open categories">
        <svg class="sidebar-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="3" y="3" width="7" height="7"></rect>
          <rect x="14" y="3" width="7" height="7"></rect>
          <rect x="14" y="14" width="7" height="7"></rect>
          <rect x="3" y="14" width="7" height="7"></rect>
        </svg>
        <span>Categories</span>
      </button>
    `;
    
    // Insert sidebar trigger next to menu button in header
    const menuButton = document.getElementById('MobileNavTrigger');
    if (menuButton) {
      menuButton.insertAdjacentHTML('afterend', sidebarTriggerHTML);
    }

    // Get elements
    const overlay = document.getElementById('sidebarOverlay');
    const drawer = document.getElementById('mobileSidebarDrawer');
    const closeBtn = document.getElementById('mobileSidebarClose');
    const sidebarTrigger = document.getElementById('mobileSidebarTrigger');

    // Open drawer with NEW sidebar trigger
    if (sidebarTrigger) {
      sidebarTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        overlay.classList.add('active');
        drawer.classList.add('active');
        document.body.style.overflow = 'hidden';
      });
    }

    // Close drawer
    function closeSidebar() {
      overlay.classList.remove('active');
      drawer.classList.remove('active');
      document.body.style.overflow = '';
    }

    closeBtn.addEventListener('click', closeSidebar);
    overlay.addEventListener('click', closeSidebar);

    // Escape key to close
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('active')) {
        closeSidebar();
      }
    });

    // Handle sidebar expand/collapse in mobile drawer - FIXED
    const sidebarItems = drawer.querySelectorAll('.sidebar-module');
    
    sidebarItems.forEach(module => {
      const header = module.querySelector('.sidebar-module__header');
      const list = module.querySelector('.sidebar-module__list');
      const expandBtn = module.querySelector('.sidebar-sublist__expand');
      const collapseBtn = module.querySelector('.sidebar-sublist__contract');
      
      if (!header || !list) return;
      
      // Initialize collapsed state
      list.style.display = 'none';
      if (expandBtn) expandBtn.style.display = 'inline-block';
      if (collapseBtn) collapseBtn.style.display = 'none';
      
      // Make the entire header clickable
      header.style.cursor = 'pointer';
      header.addEventListener('click', function(e) {
        e.preventDefault();
        toggleSidebarList(list, expandBtn, collapseBtn);
      });
      
      // Handle expand button
      if (expandBtn) {
        expandBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          toggleSidebarList(list, expandBtn, collapseBtn);
        });
      }
      
      // Handle collapse button
      if (collapseBtn) {
        collapseBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          toggleSidebarList(list, expandBtn, collapseBtn);
        });
      }
    });
    
    function toggleSidebarList(list, expandBtn, collapseBtn) {
      const isHidden = list.style.display === 'none';
      
      if (isHidden) {
        // Expand
        list.style.display = 'block';
        if (expandBtn) expandBtn.style.display = 'none';
        if (collapseBtn) collapseBtn.style.display = 'inline-block';
      } else {
        // Collapse
        list.style.display = 'none';
        if (expandBtn) expandBtn.style.display = 'inline-block';
        if (collapseBtn) collapseBtn.style.display = 'none';
      }
    }
  }

  /**
   * Desktop Search Enhancements
   */
  function initSearchEnhancements() {
    // Add search icons to desktop search bars
    const searchBars = document.querySelectorAll('.header-bar__search:not(.large--hide .header-bar__search)');
    
    searchBars.forEach(searchBar => {
      const input = searchBar.querySelector('.header-bar__search-input');
      if (input && !searchBar.querySelector('.search-icon-wrapper')) {
        const iconHTML = `
          <div class="search-icon-wrapper">
            <svg class="search-icon" viewBox="0 0 24 24">
              <circle cx="11" cy="11" r="8"></circle>
              <path d="M21 21l-4.35-4.35"></path>
            </svg>
          </div>
        `;
        searchBar.insertAdjacentHTML('afterbegin', iconHTML);
      }
    });
    
    // Initialize live search
    initLiveSearch();
  }

  /**
   * Live Search with Dropdown (Amazon-style)
   */
  function initLiveSearch() {
    const searchBars = document.querySelectorAll('.header-bar__search:not(.large--hide .header-bar__search)');
    
    searchBars.forEach(searchBar => {
      const input = searchBar.querySelector('.header-bar__search-input');
      if (!input || searchBar.querySelector('.search-dropdown')) return;
      
      // Create dropdown container
      const dropdown = document.createElement('div');
      dropdown.className = 'search-dropdown';
      searchBar.appendChild(dropdown);
      
      let searchTimeout;
      let currentIndex = -1;
      
      // Input event handler
      input.addEventListener('input', (e) => {
        const query = e.target.value.trim();
        
        clearTimeout(searchTimeout);
        
        if (query.length < 2) {
          if (query.length === 0) {
            showSearchHistory(dropdown);
          } else {
            hideDropdown(dropdown);
          }
          return;
        }
        
        searchTimeout = setTimeout(() => {
          performSearch(query, dropdown);
        }, 300);
      });
      
      // Focus event - ALWAYS show history when empty (immediate user feedback)
      input.addEventListener('focus', () => {
        const currentValue = input.value.trim();
        if (currentValue.length === 0) {
          // Show recent searches immediately on focus
          showSearchHistory(dropdown);
        } else if (currentValue.length >= 2) {
          // If there's already text, perform search
          performSearch(currentValue, dropdown);
        }
      });
      
      // Click event - also show history (better UX for users who click without typing)
      input.addEventListener('click', () => {
        if (input.value.trim().length === 0 && !dropdown.classList.contains('active')) {
          showSearchHistory(dropdown);
        }
      });
      
      // Keyboard navigation
      input.addEventListener('keydown', (e) => {
        const items = dropdown.querySelectorAll('.search-result-item, .search-history-item');
        
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          currentIndex = Math.min(currentIndex + 1, items.length - 1);
          updateActiveItem(items, currentIndex);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          currentIndex = Math.max(currentIndex - 1, -1);
          updateActiveItem(items, currentIndex);
        } else if (e.key === 'Enter' && currentIndex >= 0) {
          e.preventDefault();
          items[currentIndex].click();
        } else if (e.key === 'Escape') {
          hideDropdown(dropdown);
          currentIndex = -1;
        }
      });
      
      // Close dropdown when clicking outside
      document.addEventListener('click', (e) => {
        if (!searchBar.contains(e.target)) {
          hideDropdown(dropdown);
          currentIndex = -1;
        }
      });
    });
  }
  
  function performSearch(query, dropdown) {
    console.log('Performing search for:', query);
    
    // Show loading state
    dropdown.innerHTML = '<div class="search-loading">Searching...</div>';
    dropdown.classList.add('active');
    
    // Shopify Predictive Search API with fields to search SKU - Increased limit to 10 for better results
    const suggestUrl = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag`;
    
    // Also fetch the total count from the main search API
    const countUrl = `/search?q=${encodeURIComponent(query)}&type=product&view=json`;
    
    console.log('Fetching:', suggestUrl);
    
    // Fetch both the suggest results and the total count in parallel
    Promise.all([
      fetch(suggestUrl).then(r => r.json()),
      fetch(countUrl).then(r => r.text()).then(html => {
        // Parse HTML to extract total count
        const match = html.match(/Total results found:\s*(\d+)/i);
        return match ? parseInt(match[1]) : null;
      }).catch(() => null)
    ])
      .then(([data, totalCount]) => {
        console.log('Search data:', data, 'Total count:', totalCount);
        displayResults(query, data, dropdown, totalCount);
      })
      .catch(error => {
        console.error('Search error:', error);
        dropdown.innerHTML = '<div class="search-no-results">Error loading results. Please try again.</div>';
      });
  }
  
  function displayResults(query, data, dropdown, totalCount) {
    console.log('Displaying results for:', query, data, 'Total:', totalCount);
    
    // Handle different API response formats
    let products = [];
    
    if (data.resources && data.resources.results && data.resources.results.products) {
      products = data.resources.results.products;
    } else if (data.results && data.results.products) {
      products = data.results.products;
    } else if (data.products) {
      products = data.products;
    }
    
    console.log('Found products:', products.length);
    
    if (products.length === 0) {
      dropdown.innerHTML = '<div class="search-no-results">No products found for "' + query + '"</div>';
      return;
    }
    
    let html = '<div class="search-dropdown-section">';
    // Show the total count if we have it, otherwise show the product count
    if (totalCount && totalCount > products.length) {
      html += `<div class="search-dropdown-header">PRODUCTS (${totalCount})</div>`;
    } else {
      html += `<div class="search-dropdown-header">PRODUCTS (${products.length})</div>`;
    }
    
    products.forEach(product => {
      // DEBUG: Log product data to see what we're getting
      console.log('🔍 Product data:', {
        title: product.title,
        price: product.price,
        price_min: product.price_min,
        compare_at_price: product.compare_at_price,
        compare_at_price_max: product.compare_at_price_max,
        price_max: product.price_max
      });
      
      // Shopify price handling - This store returns prices ALREADY IN DOLLARS (not cents!)
      // Regular price - API returns in dollars for this store (227 = $227, not $2.27)
      let priceInDollars = 0;
      if (product.price) {
        priceInDollars = parseFloat(product.price);
      } else if (product.price_min) {
        priceInDollars = parseFloat(product.price_min);
      }
      
      // Get compare at price (original retail price before any sales)
      let compareAtPrice = 0;
      if (product.compare_at_price) {
        compareAtPrice = parseFloat(product.compare_at_price);
      } else if (product.compare_at_price_max) {
        compareAtPrice = parseFloat(product.compare_at_price_max);
      } else if (product.price_max && product.price_max > priceInDollars) {
        compareAtPrice = parseFloat(product.price_max);
      }
      
      // Extract SKU before using it
      let sku = '';
      if (product.variants && product.variants.length > 0) {
        if (product.variants[0].sku) {
          sku = product.variants[0].sku;
        }
      } else if (product.sku) {
        sku = product.sku;
      } else if (product.variant_sku) {
        sku = product.variant_sku;
      }
      
      // Apply SKU-based Black Friday discount
      const discountPercent = getSkuDiscount(sku);
      const additionalDiscount = priceInDollars * (discountPercent / 100);
      const finalPrice = priceInDollars - additionalDiscount;
      
      console.log('💰 Price calculation:', {
        sku,
        priceInDollars,
        compareAtPrice,
        finalPrice,
        additionalDiscount,
        discountPercent
      });
      
      // Build price HTML in the exact order requested
      let priceHTML = '';
      if (priceInDollars > 0) {
        // Show discounted price if SKU matches
        if (discountPercent > 0) {
          // 1. FIRST: Final price after Black Friday discount (blue bold)
          priceHTML = `<span style="font-weight: 700; color: #E42024;">$${finalPrice.toFixed(2)}</span>`;
          
          // 2. SECOND: Current price before the discount (crossed out)
          if (priceInDollars > finalPrice) {
            priceHTML += ` <s style="font-size: 0.9em; color: #999; margin-left: 5px;">$${priceInDollars.toFixed(2)}</s>`;
          }
          
          // 3. THIRD: Compare at price (original retail price) - only if exists and higher than current price
          if (compareAtPrice > 0 && compareAtPrice > priceInDollars) {
            priceHTML += ` <s style="font-size: 0.85em; color: #999; margin-left: 5px;">$${compareAtPrice.toFixed(2)}</s>`;
          }
          
          // Add Black Friday discount label
          priceHTML += `<br><span style="font-size: 0.75em; color: #E42024; font-weight: 600;">🔥 Black Friday: ${discountPercent}% OFF Applied!</span>`;
        } else {
          // No SKU match - show regular price
          priceHTML = `<span style="font-weight: 700; color: #008cff;">$${priceInDollars.toFixed(2)}</span>`;
          
          // Show compare at price if exists
          if (compareAtPrice > 0 && compareAtPrice > priceInDollars) {
            priceHTML += ` <s style="font-size: 0.85em; color: #999; margin-left: 5px;">$${compareAtPrice.toFixed(2)}</s>`;
          }
        }
      }
      
      console.log('📝 Generated priceHTML:', priceHTML);
      
      const image = product.image || product.featured_image || (product.images && product.images[0]) || '';
      const url = product.url || `/products/${product.handle}`;
      
      html += `
        <a href="${url}" class="search-result-item" data-product-id="${product.id}">
          ${image ? `<img src="${image}" alt="${escapeHtml(product.title)}" class="search-result-image" loading="lazy">` : ''}
          <div class="search-result-details">
            <p class="search-result-title">${highlightMatch(product.title, query)}</p>
            ${sku ? `<p class="search-result-sku" style="font-size: 12px; color: #666; margin: 2px 0;">Variants SKUs: ${highlightMatch(sku, query)}</p>` : ''}
            ${priceHTML ? `<p class="search-result-price">${priceHTML}</p>` : ''}
          </div>
        </a>
      `;
    });
    
    // Add "Show all results" button at the bottom
    html += `
      <a href="/search?q=${encodeURIComponent(query)}" class="search-show-all-btn">
        Show all results →
      </a>
    `;
    
    html += '</div>';
    dropdown.innerHTML = html;
    dropdown.classList.add('active');
    
    // Save to search history when user clicks a result
    dropdown.querySelectorAll('.search-result-item').forEach(item => {
      item.addEventListener('click', () => {
        saveToSearchHistory(query);
      });
    });
  }
  
  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
  
  function highlightMatch(text, query) {
    const regex = new RegExp(`(${query})`, 'gi');
    return text.replace(regex, '<strong>$1</strong>');
  }
  
  function showSearchHistory(dropdown) {
    const history = getSearchHistory();
    
    if (history.length === 0) {
      hideDropdown(dropdown);
      return;
    }
    
    let html = '<div class="search-dropdown-section">';
    html += '<div class="search-dropdown-header">Recent Searches</div>';
    
    history.forEach((term, index) => {
      html += `
        <div class="search-history-item" data-query="${term}">
          <svg class="search-history-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
          <span class="search-history-text">${term}</span>
          <span class="search-history-remove" data-index="${index}">✕</span>
        </div>
      `;
    });
    
    html += '</div>';
    dropdown.innerHTML = html;
    dropdown.classList.add('active');
    
    // Click history item to search
    dropdown.querySelectorAll('.search-history-item').forEach(item => {
      item.addEventListener('click', (e) => {
        if (e.target.classList.contains('search-history-remove')) {
          const index = parseInt(e.target.dataset.index);
          removeFromSearchHistory(index);
          showSearchHistory(dropdown);
        } else {
          const query = item.dataset.query;
          const input = item.closest('.header-bar__search').querySelector('.header-bar__search-input');
          if (input) {
            input.value = query;
            input.focus();
            performSearch(query, dropdown);
          }
        }
      });
    });
  }
  
  function getSearchHistory() {
    try {
      return JSON.parse(localStorage.getItem('searchHistory') || '[]');
    } catch {
      return [];
    }
  }
  
  function saveToSearchHistory(query) {
    if (!query || query.length < 2) return;
    
    let history = getSearchHistory();
    
    // Remove duplicates
    history = history.filter(item => item.toLowerCase() !== query.toLowerCase());
    
    // Add to beginning
    history.unshift(query);
    
    // Keep only last 5
    history = history.slice(0, 5);
    
    try {
      localStorage.setItem('searchHistory', JSON.stringify(history));
    } catch (error) {
      console.error('Error saving search history:', error);
    }
  }
  
  function removeFromSearchHistory(index) {
    let history = getSearchHistory();
    history.splice(index, 1);
    
    try {
      localStorage.setItem('searchHistory', JSON.stringify(history));
    } catch (error) {
      console.error('Error removing from search history:', error);
    }
  }
  
  function updateActiveItem(items, index) {
    items.forEach((item, i) => {
      if (i === index) {
        item.classList.add('active');
        item.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      } else {
        item.classList.remove('active');
      }
    });
  }
  
  function hideDropdown(dropdown) {
    dropdown.classList.remove('active');
  }

  // Handle window resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      // Re-initialize if crossing mobile/desktop breakpoint
      const wasMobile = document.body.classList.contains('mobile-view');
      const isMobile = window.innerWidth <= 768;
      
      if (wasMobile !== isMobile) {
        if (isMobile) {
          document.body.classList.add('mobile-view');
        } else {
          document.body.classList.remove('mobile-view');
          // Close any open drawers
          document.querySelectorAll('.sidebar-overlay, .mobile-search-overlay').forEach(el => {
            el.classList.remove('active');
          });
          document.querySelectorAll('.mobile-sidebar-drawer, .mobile-search-drawer').forEach(el => {
            el.classList.remove('active');
          });
          document.body.style.overflow = '';
        }
      }
    }, 250);
  });

  // Set initial state
  if (window.innerWidth <= 768) {
    document.body.classList.add('mobile-view');
  }

  /**
   * Close "Sign In For Special Pricing" modal on scroll
   * Only for DESKTOP - don't hide the mobile label
   */
  function initScrollModalClose() {
    // Only run on desktop (where modal is a hover popup)
    if (window.innerWidth <= 768) {
      return; // Don't hide on mobile - it's always visible
    }
    
    window.addEventListener('scroll', function() {
      // Close the modal immediately when scrolling starts (desktop only)
      const modalPopup = document.querySelector('.medium-down--hide .modal-popup-content.dropdown-login-menu');
      if (modalPopup) {
        modalPopup.classList.remove('dropdown-login-menu');
      }
      
      // Also handle jQuery-based modal if it exists (desktop only)
      if (typeof $ !== 'undefined') {
        $('.medium-down--hide .modal-popup-content').removeClass('dropdown-login-menu');
      }
    }, { passive: true });
  }

  /**
   * Monitor variant selection changes and update Black Friday discount display
   * This ensures the discount badge and promo only show for SKUs that actually have discounts
   */
  function initVariantDiscountUpdater() {
    console.log('🎯 Initializing variant discount updater...');
    
    // Monitor all variant selector changes (radio buttons, dropdowns, swatches)
    const variantSelectors = document.querySelectorAll(
      'input[name="id"], select[name="id"], .swatch input, .variant-input'
    );
    
    variantSelectors.forEach(selector => {
      selector.addEventListener('change', function() {
        updateDiscountDisplay(this.value || this.dataset.variantId);
      });
    });
    
    // Also monitor for variant changes triggered by Shopify theme JavaScript
    document.addEventListener('variant:change', function(event) {
      const variantId = event.detail?.variant?.id;
      if (variantId) {
        updateDiscountDisplay(variantId);
      }
    });
    
    // Check if there's a selected variant on page load
    const selectedVariantInput = document.querySelector('input[name="id"]:checked, select[name="id"]');
    if (selectedVariantInput) {
      updateDiscountDisplay(selectedVariantInput.value);
    }
  }
  
  /**
   * Update discount badge, promo display, AND SKU display based on selected variant
   */
  function updateDiscountDisplay(variantId) {
    if (!variantId) return;
    
    console.log('🔍 Checking discount for variant:', variantId);
    
    // Find the variant's SKU from the page data
    const variantSku = getVariantSku(variantId);
    if (!variantSku) {
      console.log('⚠️ No SKU found for variant:', variantId);
      return;
    }
    
    const discountPercent = getSkuDiscount(variantSku);
    console.log(`📊 SKU: ${variantSku}, Discount: ${discountPercent}%`);
    
    // Update SKU display elements
    const skuDisplays = document.querySelectorAll('.variant-sku, .product-sku .sku-value');
    skuDisplays.forEach(display => {
      if (display.classList.contains('product-sku')) {
        // For .product-sku elements, we need to preserve the copy icon
        const copyIcon = display.querySelector('.copy-icon');
        display.textContent = variantSku;
        if (copyIcon) {
          display.appendChild(copyIcon);
        }
      } else {
        // For .variant-sku or .sku-value, just update text
        display.textContent = variantSku;
      }
    });
    
    // Update discount badge
    const discountBadges = document.querySelectorAll('.black-friday-discount-badge, .discount-badge-top');
    discountBadges.forEach(badge => {
      if (discountPercent > 0) {
        badge.textContent = `-${discountPercent}%`;
        badge.style.display = '';
      } else {
        badge.style.display = 'none';
      }
    });
    
    // Update promo ticker if exists
    const promoTickers = document.querySelectorAll('.grid-promo-price, .black-friday-promo');
    promoTickers.forEach(promo => {
      if (discountPercent > 0) {
        promo.style.display = '';
        // Update the discount percentage in the promo
        const savingsLabels = promo.querySelectorAll('.grid-promo-savings, .promo-savings');
        savingsLabels.forEach(label => {
          if (label.textContent.includes('%')) {
            label.textContent = `${discountPercent}% OFF`;
          }
        });
      } else {
        promo.style.display = 'none';
      }
    });
    
    console.log(`✅ Updated SKU display (${variantSku}) and discount: ${discountPercent}% off`);
  }
  
  /**
   * Get variant SKU from variant ID by parsing page data
   */
  function getVariantSku(variantId) {
    // Try to get from variant data in the page
    if (typeof window.productVariants !== 'undefined') {
      const variant = window.productVariants.find(v => v.id == variantId);
      return variant?.sku || '';
    }
    
    // Try to get from JSON in script tag
    const productJson = document.querySelector('script[type="application/json"][data-product-json]');
    if (productJson) {
      try {
        const product = JSON.parse(productJson.textContent);
        const variant = product.variants.find(v => v.id == variantId);
        return variant?.sku || '';
      } catch (e) {
        console.error('Error parsing product JSON:', e);
      }
    }
    
    // Try to get from data attribute on variant selector
    const variantElement = document.querySelector(`[data-variant-id="${variantId}"]`);
    if (variantElement && variantElement.dataset.sku) {
      return variantElement.dataset.sku;
    }
    
    return '';
  }

  // Initialize variant discount updater after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantDiscountUpdater);
  } else {
    initVariantDiscountUpdater();
  }

  // Expose getSkuDiscount globally for use in other scripts
  window.FoxxBlackFriday = {
    getSkuDiscount: getSkuDiscount,
    updateDiscountDisplay: updateDiscountDisplay
  };

})();
